import type { ComponentType } from 'react';
import type { ChatIntegrationProvider } from '@interfaces/IChatIntegrations';
import { GoogleChatLogo, SlackLogo, TeamsLogo, WhatsAppLogo, type ILogoProps } from './platformLogos';

interface IProviderInfo {
  name: string; // Brand names are not translated.
  Logo: ComponentType<ILogoProps>;
}

export const PROVIDERS: Record<ChatIntegrationProvider, IProviderInfo> = {
  slack: { name: 'Slack', Logo: SlackLogo },
  teams: { name: 'Microsoft Teams', Logo: TeamsLogo },
  googleChat: { name: 'Google Chat', Logo: GoogleChatLogo },
  whatsapp: { name: 'WhatsApp', Logo: WhatsAppLogo },
};
